import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SocialYoutube = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      d="M19.814 6.388c.86.214 1.537.843 1.768 1.642.416 1.448.418 4.47.418 4.47s0 3.022-.418 4.47c-.23.8-.907 1.428-1.768 1.642C18.254 19 12 19 12 19s-6.255 0-7.814-.388c-.86-.214-1.537-.843-1.768-1.642C2 15.522 2 12.5 2 12.5s0-3.022.418-4.47c.23-.8.907-1.428 1.768-1.642C5.746 6 12 6 12 6s6.255 0 7.814.388Zm-4.62 6.112-5.196 2.786V9.715z"
      clipRule="evenodd"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(SocialYoutube) as SvgIcon;
export { ForwardRef as ReactComponent };
